import garage from './garage';
import reusableComp from './reusable.components';

export default {
  garage: garage,
  reusableComp: reusableComp
};
